import React, { useId } from "react";
import { motion } from "framer-motion";
import telegramService from "../../utils/telegram";

interface Segment {
  id: string;
  label: string;
}

interface SegmentedControlBaseProps {
  onChange: (id: string) => void;
}

interface SegmentedControlSegmentsProps extends SegmentedControlBaseProps {
  segments: Segment[];
  active: string;
  options?: never;
  selected?: never;
}

interface SegmentedControlOptionsProps {
  options: string[];
  selected: number;
  onChange: (index: number) => void;
  segments?: never;
  active?: never;
}

type SegmentedControlProps = SegmentedControlSegmentsProps | SegmentedControlOptionsProps;

const SegmentedControl: React.FC<SegmentedControlProps> = (props) => {
  const layoutId = useId();

  // Normalize to segments format
  const segments: Segment[] = props.segments
    ? props.segments
    : (props.options || []).map((label, i) => ({ id: String(i), label }));

  const activeId = props.segments ? props.active : String(props.selected ?? 0);

  const handleChange = (id: string) => {
    telegramService.haptic("selection");
    if (props.segments) {
      (props.onChange as (id: string) => void)(id);
    } else {
      (props.onChange as (index: number) => void)(Number(id));
    }
  };

  return (
    <div className="relative flex bg-inset rounded-xl p-1">
      {segments.map((segment) => {
        const isActive = segment.id === activeId;
        return (
          <button
            key={segment.id}
            onClick={() => handleChange(segment.id)}
            className={`relative z-10 flex-1 py-2 text-xs font-bold text-center transition-colors duration-200 rounded-lg ${
              isActive ? "text-content-primary" : "text-content-tertiary"
            }`}
          >
            {isActive && (
              <motion.div
                layoutId={layoutId}
                className="absolute inset-0 bg-surface rounded-lg shadow-card"
                transition={{ type: "spring", stiffness: 400, damping: 30 }}
              />
            )}
            <span className="relative z-10">{segment.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
